<template>
  <card class="mb-4">
    <template slot="header">
      <h3 class="mb-0">{{ title }}</h3>
    </template>

    <!-- Form groups used in grid -->
    <form ref="form" class="needs-validation" @submit.prevent="save">
      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label class="control-label"> Nombre (*) </label>

            <el-input v-model="formData.name" v-validate="modelValidations.name" name="name" placeholder="Nombre">
            </el-input>

            <small v-show="name.invalid" class="text-danger">
              {{ getError('name') }}
            </small>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label class="control-label"> Puesto </label>

            <el-input
              v-model="formData.position"
              v-validate="modelValidations.position"
              name="position"
              placeholder="Puesto"
            >
            </el-input>

            <small v-show="position.invalid" class="text-danger">
              {{ getError('position') }}
            </small>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label class="control-label"> Email (*) </label>

            <el-input v-model="formData.email" v-validate="modelValidations.email" name="email" placeholder="Email">
            </el-input>

            <small v-show="email.invalid" class="text-danger">
              {{ getError('email') }}
            </small>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-12">
          <div class="form-group">
            <label class="control-label"> Teléfono </label>

            <el-input v-model="formData.phone" v-validate="modelValidations.phone" name="phone" placeholder="Teléfono">
            </el-input>

            <small v-show="phone.invalid" class="text-danger">
              {{ getError('phone') }}
            </small>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 text-right">
          <slot name="extra-actions"></slot>
          <base-button native-type="submit" type="primary">Guardar</base-button>
        </div>
      </div>
    </form>
  </card>
</template>

<script>
import { Select, Option, Upload } from 'element-ui';
import { mapFields } from 'vee-validate';
import ContactEventBus from '@/events/buses/contacts.event';

export default {
  components: {
    [Upload.name]: Upload,
    [Select.name]: Select,
    [Option.name]: Option,
  },

  props: {
    title: {
      type: String,
      default: 'Agregar contactos',
    },

    contact: {
      type: Object,
      default: () => {
        return {
          name: null,
          position: null,
          email: null,
          phone: null,
        };
      },
    },
  },

  data() {
    return {
      validated: false,
      formData: {
        name: this.name,
        position: this.position,
        email: this.email,
        phone: this.phone,
      },

      editId: null,
      modelValidations: {
        name: {
          required: true,
          min: 3,
        },

        email: {
          email: true,
        },

        phone: {
          numeric: true,
        },

        position: {
          min: 3,
        },
      },
    };
  },

  computed: {
    ...mapFields(['name', 'position', 'email', 'phone']),
  },

  created() {
    ContactEventBus.$on('contacts-on-edit', this.onEdit);
  },

  beforeDestroy() {
    ContactEventBus.$off('contacts-on-edit', this.onEdit);
  },

  methods: {
    onEdit(contact) {
      this.clean();
      this.formData.name = contact.name;
      this.formData.position = contact.position;
      this.formData.email = contact.email;
      this.formData.phone = contact.phone;
      this.editId = contact.id;
    },

    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          if (this.editId) {
            this.update();
          } else {
            this.$emit('save', this.formData);
          }
        }
      });
    },

    create(contact, contactableId, contactableType) {
      const payload = Object.assign(contact, {
        contactableId: contactableId,
        contactableType: contactableType,
      });

      this.$services
        .resource('contacts')
        .create(payload)
        .then((res) => res.data.data)
        .then((data) => {
          this.reset();
          ContactEventBus.addToList(data);
        });
    },

    update() {
      this.$services
        .resource('contacts')
        .update(this.editId, this.formData)
        .then((res) => res.data.data)
        .then((data) => {
          this.reset();
          ContactEventBus.update(data);
        });
    },

    clean() {
      this.formData.name = null;
      this.formData.position = null;
      this.formData.phone = null;
      this.formData.email = null;
      this.errors.clear();
      this.$validator.reset();
    },

    reset() {
      this.$refs.form.reset();
      this.editId = null;
      this.clean();
    },

    getError(name) {
      return this.errors.first(name);
    },

    isValid(name) {
      return this.validated && !this.errors.has(name);
    },
  },
};
</script>
